'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Progress = undefined;

var _components = require('@rebass/components');

var _components2 = _interopRequireDefault(_components);

var _styledSystem = require('styled-system');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Progress = exports.Progress = (0, _components2.default)({
  is: 'progress',
  width: 1,
  m: 0,
  px: 0,
  color: 'blue',
  bg: 'gray',
  borderRadius: 2
}, 'width', 'borderRadius', 'space', 'color', function (props) {
  return {
    boxSizing: 'border-box',
    diplay: 'block',
    height: '4px',
    overflow: 'hidden',
    appearance: 'none',
    '&::-webkit-progress-bar': {
      backgroundColor: (0, _styledSystem.themeGet)('colors.gray')(props)
    },
    '&::-webkit-progress-value': {
      backgroundColor: 'currentcolor'
    },
    '&::-moz-progress-bar': {
      backgroundColor: 'currentcolor'
    }
  };
});

Progress.displayName = 'Progress';

exports.default = Progress;


//////////////////
// WEBPACK FOOTER
// ./~/rebass/dist/Progress.js
// module id = 144
// module chunks = 22676092666560 46504955462500 107818501498521 221374088121123